export enum BARKODE_TYPE {
  ALL = 0,
  KNISA = 1,
  PALLET = 2,
}
export interface IResponseSrikaNode {
  entryLine: ISrikaItem[],  
}

export interface ISrikaItem {
  AmountPack: number
  AvgWeightPerPack: number
  BalanceAmount: number
  BalanceWeight: number
  Gross: number
  GrowerName: string
  GrowerID: number
  MandatoryWeight: boolean
  PackID: number
  Pack_Name: string
  PackageTareWeight: number
  Pallete_Desc: string
  ProductCalculationMethod: number
  ProductDesc: string
  ProductFamilyDesc: string
  ProductFamilyId: number
  ProductID: number
  SizeDesc: string
  SizeNum: number
  Tranzit: number
  VarietyDesc: string
  VarietyID: number,
  GeneralProductID: number
  // Quality: number
  Quantity_Packs_Main: number
  PackID_Secondary: number
  Quantity: number
  PalletID: number
  BarcodeID: number
}
export interface IResponseSrikaGo extends IResponseSrikaNode {
  
}